import $api from "http";

export async function postTabel(formdata) {
    return $api.post(`/tabel/`, formdata ,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }); 
  }

  

  export async function getTabel(data) {
    return $api.get(`/mytabel/`, data);
  }
  export async function getTabelLast(data) {
    return $api.get(`/mytabellast/`, data);
  }
  
  // export async function getQrInfo(data) {
  //   return $api.get(`/qr_organization/`, data);
  // }
  // Получить данные водителя по uid
  export async function getDriverByUid(uid) {
    return $api.get(`/tabel/driver-by-uid/${uid}/`);
  }

  // Отправить отметку о въезде по uid водителя
  export async function postLoadByDriverUid(uid, payload) {
    return $api.post(`/tabel/load-by-driver-uid/${uid}/`, payload);
  }

  // Получить список заблокированных водителей
  export async function getBlockedDrivers() {
    return $api.get(`/tabel/blocked-drivers/`);
  }
  